__webpack_require__.p = "/samurai_way_ts/";